import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import ProfileSettings from "./ProfileSettings";
import Billing from "./Billing";
import People from "./People";
// import SecuritySettings from "./SecuritySettings";
import SideNav from "./sidenav";
import PageNotFound from "../../UtilityComponents/pageNotFound";

function OrganizationSettings(props) {

  document.title = "Organization settings | Em Console Webapp | Techforce";

  
  let { organizations, history, match } = props;
  const [ organization, setOrganization] = useState({})
    
  useEffect(() => {
    if(organizations.data.length > 0){
      let org = match.params.organization;
      let organization = organizations.data.find((obj) => obj.display_name === org);
      if(organization){
        setOrganization(organization)
      }
      else{
        history.push("/");
      }
    }else{
      history.push("/")
    }
  }, [match, history, organizations]);

  if(organization.display_name && organization.role_id === 1){
    return (
      <div className="settings-container">
        <SideNav organization={organization} />
        <div className="main-content">
          <Switch>
            <Route
              path="/organizations/:organization/settings/profile"
              render={props => (
                <ProfileSettings {...props} organization={organization} />
              )}
            ></Route>
            <Route
              path="/organizations/:organization/settings/billing"
              render={props => (
                <Billing {...props} organization={organization} />
              )}
            />
            <Route
              path="/organizations/:organization/settings/people"
              render={props => (
                <People {...props} organization={organization} />
              )}
            />
            <Redirect
              from="/organizations/:organization/settings"
              to="/organizations/:organization/settings/profile"
            />
          </Switch>
        </div>
      </div>
    );
  }else{
    return <PageNotFound history={history}/>
  }
}

const mapStateToProps = state => ({
  user: state.user,
  organizations: state.organizations
});

export default connect(mapStateToProps, null)(OrganizationSettings);